// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  min-height: 0;
}

.scorecard {
  background: #fff;
  border: 1px solid #d9dee7;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(19, 42, 70, 0.08);
  height: 100%;
  overflow: hidden;
}

h2 {
  background: #1f4e78;
  color: #fff;
  font-size: 1rem;
  margin: 0;
  padding: 0.65rem 0.9rem;
}

.score-table {
  display: grid;
}

.score-row {
  align-items: center;
  display: grid;
  font-size: 0.82rem;
  gap: 0.5rem;
  grid-template-columns: minmax(0, 2fr) repeat(3, minmax(70px, 0.7fr));
  min-height: 36px;
  padding: 0.35rem 0.75rem;
}

.score-row:nth-child(odd):not(.score-header) {
  background: #f5f8fb;
}

.score-header {
  background: #d9eaf7;
  color: #18364f;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
}

.score-row span:not(:first-child) {
  text-align: center;
}

.compatibility {
  color: #176b39;
  font-weight: 700;
}
`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/lab-audit-checklist/components/audit-score-summary/audit-score-summary.component.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,4CAA4C;EAC5C,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,oEAAoE;EACpE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB","sourcesContent":[":host {\n  display: block;\n  min-height: 0;\n}\n\n.scorecard {\n  background: #fff;\n  border: 1px solid #d9dee7;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(19, 42, 70, 0.08);\n  height: 100%;\n  overflow: hidden;\n}\n\nh2 {\n  background: #1f4e78;\n  color: #fff;\n  font-size: 1rem;\n  margin: 0;\n  padding: 0.65rem 0.9rem;\n}\n\n.score-table {\n  display: grid;\n}\n\n.score-row {\n  align-items: center;\n  display: grid;\n  font-size: 0.82rem;\n  gap: 0.5rem;\n  grid-template-columns: minmax(0, 2fr) repeat(3, minmax(70px, 0.7fr));\n  min-height: 36px;\n  padding: 0.35rem 0.75rem;\n}\n\n.score-row:nth-child(odd):not(.score-header) {\n  background: #f5f8fb;\n}\n\n.score-header {\n  background: #d9eaf7;\n  color: #18364f;\n  font-size: 0.72rem;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.score-row span:not(:first-child) {\n  text-align: center;\n}\n\n.compatibility {\n  color: #176b39;\n  font-weight: 700;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
